import { Component, OnInit } from '@angular/core';
import {OrganisationPreferencesService} from '../../../../_services/organisation/organisation-preferences.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'acabim-admin-onboarding-actions-auto-execute',
  templateUrl: './onboarding-actions-auto-execute.component.html',
  styleUrls: ['../styles.scss', './onboarding-actions-auto-execute.component.scss']
})
export class OnboardingActionsAutoExecuteComponent implements OnInit {

  isLoading = false;
  active = false;

  constructor(
      private readonly organisationPreferencesService: OrganisationPreferencesService
  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.organisationPreferencesService.getPreferences().subscribe(data => {
      if (data) {
        this.active = data.run_action_tasks;
        this.isLoading = false;
      }
    });
  }

  submit(value: boolean) {
    this.organisationPreferencesService.updatePreference('run_action_tasks', value).subscribe(res => {
      this.getPreferences();
    });
  }

} // EOC
